import React, { useState } from 'react';
import { Input, InputNumber, message } from 'antd';
import { TbButton, TbFormItem, TbImgSelect } from '../../components';
import { generateShortUrl } from '../../../../api/taobao';
import useStatistic, { useClickStatistic } from '../../hooks/useStatistic';
import { convertImageToCanvas } from './utils';
import Preview from './Preview/Preview';
import './style.less';

const { TextArea } = Input;
message.config({
  top: 160,
  duration: 1,
  maxCount: 3,
});

const clsPrefix = 'cn-qrcode';
const QrCode:React.FC<{}> = () => {
  const [ imgList, setImgList ] =useState<any[]>([])
  const [ imgBase, setImgBase ] = useState<any>('');
  const [ imgUrl, setImgUrl ] = useState<any>('');
  const [ goodsType, setGoodsType ] = useState('');
  const [ originPrice, setOriginPrice ] = useState<number>();
  const [ goodsTitle, setGoodsTitle ] = useState('');
  const [ couponValue, setCouponValue ] = useState<number>();
  const [ finalPrice, setFinalPrice ] = useState<number>();
  const [ qrcodeUrl, setQrcodeUrl ] = useState('');
  const [ isConverting, setIsConverting ] = useState(false);

  useStatistic('taobaoke-qrcode');


  function handleBase64(img: Blob) {
    if (imgUrl && imgUrl.length > 0) {
      message.info('您已选择了一张图片')
      return;
    }

    convertImageToCanvas(img).then((canvas) => {
      setImgBase(canvas)
      setImgUrl(undefined)
    }).catch((error) => message.error(error))
  }

  function handleUploadChange(fileList: any[]) {
    setImgList(fileList);
    setImgUrl(undefined);
  }

  function handleImgUrlChange(e:React.ChangeEvent<HTMLInputElement>) {
    if (imgBase && imgBase.length > 0) {
      setImgUrl('')
      message.info('您已选择了一张图片');
    } else {
      convertImageToCanvas(e.target.value).then((canvas) => {
        setImgUrl(canvas);
        setImgBase(undefined);
        setImgList([]);
      }).catch((error) =>{
        message.error(error)
        setImgUrl(undefined);
      })

    }
  }

  function convertShortUrl() {
    // 检查是否带上协议
    if (!qrcodeUrl.startsWith('http') && !qrcodeUrl.startsWith('https')) {
      message.info('输入的网址需要以http或者https开头');
      return;
    } 

    setIsConverting(true);
    generateShortUrl({
      type: 1,
      urls: [qrcodeUrl],
    }).then((data: any) => {
      setQrcodeUrl(data.urls[0]);
      setIsConverting(false)
    }).catch(() => setIsConverting(false))
  }

  function handleClear() {
    setImgBase('');
    setImgUrl('');
    setGoodsType('');
    setOriginPrice(undefined);
    setCouponValue(undefined);
    setFinalPrice(undefined);
    setQrcodeUrl('');
    setImgList([])
  }

  return (
    <div className={clsPrefix}>
        <div className={`${clsPrefix}__form`}>
          <div className={`${clsPrefix}__title`}>生成二维码商品推广图</div>
          <TbFormItem label="外观设置" style={{ marginBottom: '16px' }}>
            <div className={`${clsPrefix}__form--items`}>
              <TbImgSelect
                handleBase64={handleBase64}
                handleRemove={() => setImgBase('')}
                handleChange={(fileList) => handleUploadChange(fileList)}
                outerImgList={imgList}
              />
              <TbFormItem label="输入图片地址：" style={{ marginBottom: '0px'}}>
                <Input style={{ width: '406px' }} disabled={imgBase || (imgList && imgList.length > 0)} onBlur={handleImgUrlChange} />
              </TbFormItem>
            </div>
          </TbFormItem>

          <div className={`${clsPrefix}__form--items`}>
            <TbFormItem label="输入商品类型：" style={{ marginBottom: '16px' }}>
              <Input maxLength={10} style={{ width: '258px' }} value={goodsType} onChange={e => setGoodsType(e.target.value)} />
            </TbFormItem>
            <TbFormItem label="输入商品原价：" style={{ marginBottom: '16px' }}>
              <InputNumber
                min={0}
                placeholder="请输入不超过9位数字"
                style={{ width: '258px' }}
                value={originPrice}
                onChange={value => {
                  if (value && String(value).length > 9) {
                    setFinalPrice(Number(String(value).slice(0,9)));
                    return;
                  }
                  setOriginPrice(value);
                }} />
            </TbFormItem>
          </div>

          <TbFormItem label="输入商品标题：" style={{ marginBottom: '16px' }}>
            <TextArea 
              rows={2}
              className={`${clsPrefix}__form--textarea`}
              style={{ height: '68px' }}
              value={goodsTitle}
              onChange={e => setGoodsTitle(e.target.value)}
              maxLength={40}
            />
          </TbFormItem>

          <div className={`${clsPrefix}__form--items`}>
            <TbFormItem label="输入优惠券面额：" style={{ marginBottom: '16px' }}>
              <InputNumber
                min={0}
                placeholder="请输入不超过9位数字"
                style={{ width: '258px' }}
                value={couponValue}
                onChange={value => {
                  if (value && String(value).length > 9) {
                    setFinalPrice(Number(String(value).slice(0,9)));
                    return;
                  }
                  setCouponValue(value);
                }}
              />
            </TbFormItem>
            <TbFormItem label="输入券后价格：" style={{ marginBottom: '16px' }}>
              <InputNumber
                min={0}
                placeholder="请输入不超过9位数字"
                style={{ width: '258px' }}
                value={finalPrice}
                onChange={value => {
                  if (value && String(value).length > 9) {
                    setFinalPrice(Number(String(value).slice(0,9)));
                    return;
                  }
                  setFinalPrice(value);
                }}
              />
            </TbFormItem>
          </div>

          <TbFormItem label="输入要生成的二维码链接：" style={{ marginBottom: '16px' }}>
            <div className={`${clsPrefix}__form--items`}>
              <Input style={{ width: '390px' }} value={qrcodeUrl} onChange={e => setQrcodeUrl(e.target.value)} />
              <TbButton loading={isConverting} disabled={!qrcodeUrl} content="转换为短链接" theme="primary" width="129px" onClick={convertShortUrl} />
            </div>
          </TbFormItem>
        </div>
        <div className={`${clsPrefix}__division`}></div>
        <div className={`${clsPrefix}__preview`}>
          <Preview 
            imgUrl={imgBase || imgUrl}
            goodsTitle={goodsTitle}
            goodsType={goodsType}
            originPrice={originPrice}
            couponValue={couponValue}
            finalPrice={finalPrice}
            qrcode={qrcodeUrl}
            onClear={handleClear}
          />
        </div>
        
    </div>
  );
}

export default QrCode;